import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLuebeck() {
  return (
    <CityPageTemplate
      city="Lübeck"
      slug="luebeck"
      intro="Die Hansestadt Lübeck mit ihrer reichen Geschichte – Deine Finanzen sollten genauso solide aufgestellt sein."
      description="Unabhängige & digitale Finanzberatung für Lübeck: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
